import type {FC} from 'react';
import Link from 'next/link';

import type {ButtonProps} from '@/modules/foundation/components/button';
import {Button} from '@/modules/foundation/components/button';

export type CallToActionProps = {
	href: string;
	targetBlank?: boolean;
	text: string;
	variant?: ButtonProps['variant'];
	className?: string;
};

export const CallToAction: FC<CallToActionProps> = ({
	href,
	targetBlank,
	text,
	variant,
	className,
}) => {
	return (
		<Button asChild variant={variant} className={className}>
			<Link href={href} {...(targetBlank && {target: '_blank'})}>
				{text}
			</Link>
		</Button>
	);
};
